import { render, staticRenderFns } from "./purshase-products-list.vue?vue&type=template&id=1ee9e32e"
import script from "./purshase-products-list.vue?vue&type=script&lang=js"
export * from "./purshase-products-list.vue?vue&type=script&lang=js"
import style0 from "./purshase-products-list.vue?vue&type=style&index=0&id=1ee9e32e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports